<template>
  <!-- Modal other files -->
  <div
    class="modal fade"
    id="us-address-confirmation"
    tabindex="-1"
    role="dialog"
    aria-labelledby="usAddressConfirmation"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div>
          <div class="modal-header">
            <span class="modal-title-new" id="termsLabel">{{ $t('Sepetinize “Adres Paketi” eklenecektir') }}</span>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          </div>
          <div class="modal-body modal-body-min">
            <div class="alert-field-new">
              <div>
                <img src="/img/icons/goal.svg" alt="" />
              </div>
              <span class="alert-text-new">
                {{
                  $t(
                    'Şirket kuruluşu için bir yasal temsilci ve iş adresiniz olması ve Adres Paketi aboneliği zorunludur'
                  )
                }}
              </span>
            </div>
            <div class="recommend-field">
              <div class="recommend-main-field">
                <div class="recommend-badge-field">
                  <div>
                    <img src="/img/icons/note.svg" alt="" />
                  </div>
                  <span>{{ $t('Şirket Kuruluşu için gerekli') }}</span>
                </div>
                <div class="product-name-new">{{ getProductName(addressPackage) }}</div>
                <div class="new-product-features">
                  <div v-for="(feature, index) in addressFeatures" :key="index" class="d-flex align-items-center">
                    <div class="new-product-feature-item">{{ feature.text }}</div>
                  </div>
                </div>
              </div>
              <div class="recommend-price-field">
                <div class="new-price-field">
                  <span class="new-price"
                    >{{ formatPrice(addressPackage.net_price, addressPackage.currency) + ' ' }}
                  </span>
                  <span class="fee-text">
                    {{
                      addressPackage.type === 'subscription'
                        ? addressPackage.period === 'annual'
                          ? ' /' + $t('Yıl')
                          : ' /' + $t('Ay')
                        : ''
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn button-type-outline-light" data-dismiss="modal">{{ $t('Vazgeç') }}</button>
          <button @click="confirm" type="button" class="btn btn-mukellef" data-dismiss="modal">
            {{ $t('Devam Et') }}
          </button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
  <!-- Modal terms -->
</template>
<script>
export default {
  name: 'usAddressConfirmation',
  props: {
    addressPackage: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      addressFeatures: this.$t('Us Address Maddeleri'),
    };
  },
  methods: {
    confirm() {
      this.$emit('confirm-address-package');
    },
  },
};
</script>

<style lang="less" scoped>
.modal-dialog {
  max-width: 659px !important;
  padding: 8px !important;
}
.alert-field-new {
  background: rgba(0, 170, 107, 0.1);
  border-radius: 12px;
  border: 1px solid #ddd;
  padding: 16px;
  display: flex;
  gap: 8px;
}

.modal-title-new {
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  font-weight: 500;
  color: black;
}
.recommend-field {
  background: white;
  box-shadow: 0px 1px 39.1px 0px rgba(165, 165, 165, 0.25);
  border-radius: 16px;
  border: 1px solid #ddd;
  padding: 24px;
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  flex-direction: row;
  @media (max-width: 576px) {
    flex-direction: column;
  }
}
.recommend-main-field {
  display: inline-block;
}
.recommend-badge-field {
  padding: 4px;
  background: #00aa6b;
  display: inline-flex;
  gap: 8px;
  border-radius: 4px;
  font-size: 14px;
  line-height: 21px;
  color: white;
  font-weight: 500;
}
.product-name-new {
  font-size: 14px;
  line-height: 21px;
  font-weight: 500;
  color: black;
  margin-top: 8px;
}
.new-product-features {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
  .new-product-feature-item {
    background: #f1fafe;
    padding: 4px 12px 4px 8px;
    text-align: center;
    border-radius: 4px;
    font-size: 14px;
    line-height: 21px;
    color: black;
    font-weight: 500;
  }
}
.recommend-price-field {
  align-self: flex-end;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  padding: 8px;
  @media (max-width: 576px) {
    align-self: stretch;
  }
}
.new-price-field {
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  .new-price {
    color: black;
    font-size: 16px;
    line-height: 24px;
  }
  .fee-text {
    color: black;
    font-size: 12px;
    line-height: 18px;
  }
}
</style>

<style lang="less">
.fadeonly-enter-active,
.fadeonly-leave-active {
  transition: opacity 0.6s ease;
}

.fadeonly-enter-from,
.fadeonly-leave-to {
  opacity: 0;
}
</style>
